import { motion } from "motion/react";

/**
 * Blobs flous décoratifs pour les blocs CTA : pulsation/flottement très doux en boucle.
 * Sous prefers-reduced-motion, MotionConfig neutralise les transforms (blobs figés).
 */
export default function CtaBlobs() {
  return (
    <>
      <motion.div
        className="absolute -top-12 -right-12 w-56 h-56 bg-honey/30 rounded-full blur-3xl pointer-events-none"
        animate={{ scale: [1, 1.15, 1], x: [0, 12, 0], y: [0, -10, 0] }}
        transition={{ duration: 11, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute -bottom-16 -left-10 w-64 h-64 bg-terra/30 rounded-full blur-3xl pointer-events-none"
        animate={{ scale: [1, 1.12, 1], x: [0, -14, 0], y: [0, 12, 0] }}
        transition={{ duration: 13, repeat: Infinity, ease: "easeInOut", delay: 1.5 }}
      />
    </>
  );
}
